import { TTheme } from '@/core/theme'
import { styled } from '@mui/system'

export const alwaysShowScrollbar = `
    ::-webkit-scrollbar {
        -webkit-appearance: none;
        width: 7px;
    }

    ::-webkit-scrollbar-thumb {
        border-radius: 4px;
        background-color: rgba(0, 0, 0, 0.5);
        box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
    }
`

export const Body = styled('div')<{ theme?: TTheme }>`
    flex-direction: column;
    display: flex;
    flex-shrink: 0;
    padding: 0 0 36px;
    border-bottom: 1px solid
        ${({ theme }) => theme.colors.semantic.drawerSeparator};

    p {
        min-height: 26px;
    }
`

export const DomainRow = styled('div')<{ theme?: TTheme }>`
    display: flex;
    flex-direction: row;
    align-items: center;
    min-width: 0;
    transition: all 0.2s linear;

    &:hover {
        .close-icon {
            visibility: visible;
        }
    }

    &.deleted {
        .MuiFormControlLabel-label {
            color: ${({ theme }) => theme.colors.greys[400]};
            text-decoration: line-through;
            text-decoration-thickness: 2px;
            text-decoration-color: ${({ theme }) => theme.colors.greys[800]};
        }

        .restore-icon {
            visibility: visible;
        }
    }

    .close-icon {
        display: inline-flex;
        align-items: center;
        visibility: hidden;
        margin-left: 20px;
        cursor: pointer;
        &:hover {
            svg {
                transition: all 0.2s linear;
                fill: var(--color-dark-200);
            }
        }
    }

    .restore-icon {
        display: inline-flex;
        align-items: center;
        margin-left: 20px;
        cursor: pointer;
        svg {
            transition: all 0.2s linear;
            fill: ${({ theme }) => theme.colors.greys[500]};
        }
        &:hover {
            svg {
                fill: ${({ theme }) => theme.colors.primary[500]};
            }
        }
    }
`

export const DomainsWrapper = styled('div')`
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 14px;
`
